<cui-simple-shared-layout></cui-simple-shared-layout>
